<!-- Komponen PDF Generator (Hidden from UI) -->
<template>
  <vue-html2pdf
    ref="html2Pdf"
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="false"
    :paginate-elements-by-height="2000"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    pdf-content-width="100%"
    :html-to-pdf-options="{
      margin: [8, 8, 8, 8],
      filename: `Invoice-${data.order_no || 'Komerce'}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: 'avoid-all' }
    }"
    @hasStartedGeneration="$emit('loading', true)"
    @hasGenerated="$emit('loading', false)"
  >
    <section
      slot="pdf-content"
      class="p-2 w-full flex flex-col bg-white overflow-hidden text-[12px] text-[#333333]"
      style="font-family: 'Helvetica', 'Arial', sans-serif;"
    >
      <!-- ========== DETAIL ORDER ========== -->
      <div class="border border-[#EEEEEE] rounded-lg p-[14px_16px] mb-1">
        <div class="text-[#E31A1A] text-[13px] font-semibold mb-[10px]">
          Detail Order
        </div>
        <div class="flex gap-6">
          <!-- Left Column -->
          <div class="flex-1">
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">Tanggal Order:</span>
              <span class="block text-[#222222] text-[12px]">{{ FULL_DATE_TIME(data.order_date) }}</span>
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">No. Order:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ data.order_no }}</span>
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">Metode Pembayaran:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ data.payment_method }}</span>
            </div>
          </div>

          <!-- Right Column -->
          <div class="flex-1">
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[8px]">Ekspedisi:</span>
              <div class="flex items-center gap-[6px]">
                <img
                  :src="iconExpeditions[data.shipping]"
                  :alt="data.shipping"
                  class="w-[50px] h-auto object-contain"
                >
              </div>
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">No. Resi:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ data.airway_bill || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== DETAIL PENGIRIM & PENERIMA ========== -->
      <div class="border border-[#EEEEEE] rounded-lg p-[14px_16px] mb-1">
        <div class="flex gap-6">
          <!-- Detail Pengirim -->
          <div class="flex-1">
            <div class="text-[#E31A1A] text-[13px] font-semibold mb-[10px]">
              Detail Pengirim
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">Nama Pengirim:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ data.partner_information.partner_name || '-' }}</span>
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">No. HP:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ `62${data.partner_information.partner_phone_number}` || '-' }}</span>
            </div>
          </div>

          <!-- Detail Penerima -->
          <div class="flex-1">
            <div class="text-[#E31A1A] text-[13px] font-semibold mb-[10px]">
              Detail Penerima
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">Nama Penerima:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ data.customer_name || '-' }}</span>
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">No. HP:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ `62${data.customer_phone}` || '-' }}</span>
            </div>
            <div class="mb-[6px]">
              <span class="block text-[#777777] text-[11px] mb-[2px]">Alamat Tujuan:</span>
              <span class="block text-[#222222] text-[12px] font-bold">{{ data.customer_address || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== PRODUCT TABLE ========== -->
      <div class="mb-1">
        <table class="w-full border-collapse">
          <thead>
            <tr class="bg-[#F8F9FA]">
              <th class="font-semibold text-[12px] text-[#333333] p-[8px_10px] text-left border-b border-[#EEEEEE]">
                Nama Produk
              </th>
              <th
                v-if="showPrice"
                class="font-semibold text-[12px] text-[#333333] p-[8px_10px] text-left border-b border-[#EEEEEE]"
              >
                Harga
              </th>
              <th class="font-semibold text-[12px] text-[#333333] p-[8px_10px] text-left border-b border-[#EEEEEE]">
                Jumlah
              </th>
              <th
                v-if="showPrice"
                class="font-semibold text-[12px] text-[#333333] p-[8px_10px] text-left border-b border-[#EEEEEE]"
              >
                Subtotal
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(product, index) in productList"
              :key="index"
            >
              <td class="p-[10px] border-b border-[#F0F0F0] align-middle text-[12px] text-[#222222]">
                <div class="flex items-center gap-2">
                  <div>
                    <div class="text-[12px] text-[#222222]">
                      {{ product.product_name }}
                    </div>
                    <div
                      v-if="product.variant_name"
                      class="text-[11px] text-[#E31A1A] mt-[2px]"
                    >
                      {{ product.variant_name }}
                    </div>
                  </div>
                </div>
              </td>
              <td
                v-if="showPrice"
                class="p-[10px] border-b border-[#F0F0F0] align-middle text-[12px] text-[#222222]"
              >
                {{ IDR(getPrice(product).price) }}
              </td>
              <td class="p-[10px] border-b border-[#F0F0F0] align-middle text-[12px] text-[#222222]">
                {{ product.qty }}
              </td>
              <td
                v-if="showPrice"
                class="p-[10px] border-b border-[#F0F0F0] align-middle text-[12px] text-[#222222]"
              >
                {{ IDR(getPrice(product).sumPrice) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ========== FOOTER: CATATAN + SUMMARY ========== -->
      <div class="flex gap-5 items-start">
        <!-- Catatan Order (Left) -->
        <div class="flex-1">
          <div
            v-if="data.order_notes"
            class="mr-1"
          >
            <div class="font-semibold text-[12px] text-[#333333] mb-[6px]">
              Catatan Order
            </div>
            <div class="border border-[#EEEEEE] rounded-md p-[10px_12px] text-[11px] text-[#555555] leading-[1.5] min-h-[50px]">
              {{ data.order_notes }}
            </div>
          </div>
        </div>

        <!-- Cost Summary (Right) -->
        <div class="flex-1">
          <div class="flex justify-between pb-1 text-[12px] text-[#333333]">
            <span>Total Harga Produk</span>
            <span>{{ IDR(adjustedSubtotal) }}</span>
          </div>
          <div class="flex justify-between pb-1 text-[12px] text-[#333333]">
            <span>Ongkos Kirim</span>
            <span>{{ IDR(data.shipping_cost) }}</span>
          </div>
          <div class="flex justify-between pb-1 text-[12px] text-[#333333]">
            <span>Potongan Harga</span>
            <span class="text-[#E31A1A]">{{ data.discount > 0 ? '-' : '' }}{{ IDR(data.discount) }}</span>
          </div>
          <div class="flex justify-between pb-1 text-[12px] text-[#333333]">
            <span>Biaya Lain-lain</span>
            <span class="text-[#E31A1A]">{{ data.additional_cost > 0 ? '+' : '' }}{{ IDR(data.additional_cost) }}</span>
          </div>
          <div class="flex justify-between mt-[6px] pt-1 pb-1 border-t border-[#EEEEEE] text-[14px]">
            <span class="font-bold">Grand Total</span>
            <span class="font-bold text-[#E31A1A]">{{ IDR(data.grandtotal) }}</span>
          </div>
          <div class="flex justify-between mt-[6px] pt-1 border-t border-[#EEEEEE] text-[14px]">
            <span class="font-bold">Penghasilan Bersih</span>
            <span class="font-bold text-success">{{ IDR(adjustedProfit) }}</span>
          </div>
        </div>
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
// eslint-disable-next-line import/no-extraneous-dependencies
import html2canvas from 'html2canvas'
import { FULL_DATE_TIME } from '@/libs/filterDate'
import { IDR } from '@/libs/currency'

export default {
  components: {
    VueHtml2pdf,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IDR,
      FULL_DATE_TIME,
      iconExpeditions: {
        SAP: 'https://storage.googleapis.com/komerce/assets/LP-Komship/SAPX.svg',
        SPX: 'https://storage.googleapis.com/komerce/assets/LP-Kompack/spx.svg',
        SICEPAT: 'https://storage.googleapis.com/komerce/assets/LP-Komship/Sicepat.webp',
        NINJA: 'https://storage.googleapis.com/komerce/assets/LP-Komship/Ninja.svg',
        LION: 'https://storage.googleapis.com/komerce/Komship/Lion.svg',
        JNE: 'https://storage.googleapis.com/komerce/assets/logo/jne.svg',
        'J&T': 'https://storage.googleapis.com/komerce/assets/LP-Komclass/jnt.svg',
        JNT: 'https://storage.googleapis.com/komerce/assets/LP-Komclass/jnt.svg',
        IDEXPRESS: 'https://storage.googleapis.com/komerce/core/icons/logo-idexpress.svg',
      },
    }
  },
  computed: {
    productList() {
      return this.data.product || []
    },
    isCompact() {
      return this.productList.length > 4
    },
    adjustedSubtotal() {
      const { data } = this
      return (data.grandtotal || 0) - (data.shipping_cost || 0) - (data.additional_cost || 0) + (data.discount || 0)
    },
    adjustedProfit() {
      const { data } = this
      return (data.grandtotal || 0) - ((data.shipping_cost || 0) - (data.shipping_cashback || 0)) - (data.insurance_fee || 0) - (data.service_fee || 0)
    },
  },
  methods: {
    generate() {
      this.$refs.html2Pdf.generatePdf()
    },
    async generateImage() {
      this.$emit('loading', true)
      try {
        const pdfContent = this.$refs.html2Pdf.$el.querySelector('[slot="pdf-content"]')
          || this.$refs.html2Pdf.$el.querySelector('section')
        if (!pdfContent) throw new Error('Invoice content not found')

        const clone = pdfContent.cloneNode(true)
        Object.assign(clone.style, {
          overflow: 'visible',
          width: '794px',
          padding: '16px',
          backgroundColor: '#ffffff',
          position: 'fixed',
          left: '-9999px',
          top: '0',
          zIndex: '-1',
        })

        document.body.appendChild(clone)
        await new Promise(resolve => { setTimeout(resolve, 300) })

        const canvas = await html2canvas(clone, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
          width: 794,
          scrollY: 0,
          scrollX: 0,
        })

        document.body.removeChild(clone)

        const link = document.createElement('a')
        link.download = `Invoice-${this.data.order_no || 'Komerce'}.png`
        link.href = canvas.toDataURL('image/png')
        link.click()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to generate invoice image:', error)
      } finally {
        this.$emit('loading', false)
      }
    },
    getPrice(product) {
      const { adjustedSubtotal, productList } = this

      const customPrice = adjustedSubtotal === this.data.subtotal
      const totalQty = productList.reduce((acc, item) => acc + item.qty, 0)
      const price = totalQty > 0 ? adjustedSubtotal / totalQty : 0

      return {
        price: customPrice ? product.price : price,
        sumPrice: customPrice ? product.price * product.qty : price * product.qty,
      }
    },
  },
}
</script>

<style scoped>
/* Only keep styles that Tailwind can't easily handle */
.compact-mode .border {
  padding: 10px 12px !important;
  margin-bottom: 8px !important;
}

.compact-mode table td {
  padding: 6px 10px !important;
}
</style>
